module.exports = __webpack_public_path__ + "static/media/fabioImg.4a5de01e.svg";